import { API_CONFIG } from "../config";

const createEndpoints = (baseURL: string) => {
  const base = `${baseURL}/api/v1`;

  return {
    AUTH: {
      BASE: `${base}/auth`,
      LOGIN: `${base}/auth/login`,
      SIGNUP: `${base}/auth/signup`,
      LOGOUT: `${base}/auth/logout`,
      REFRESH_TOKEN: `${base}/auth/refresh`,
      CONFIRM_EMAIL: `${base}/auth/confirm`,
      VERIFY_TOKEN: `${base}/auth/verify-token`,
      FORGOT_PASSWORD: `${base}/auth/forgot-password`,
      RESET_PASSWORD: `${base}/auth/reset-password`,
      RESEND_VERIFICATION: `${base}/auth/resend-verification`,
      ME: `${base}/auth/me`,
    },

    USERS: {
      BASE: `${base}/users`,
      ME: `${base}/users/me`,
      ME_RESILIATION: `${base}/users/me/resiliation`,
      BY_ID: (id: string) => `${base}/users/${id}`,
      PROFILE: `${base}/users/profile`,
      PREFERENCES: `${base}/users/preferences`,
      CHANGE_PASSWORD: `${base}/users/change-password`,
      AVATAR: `${base}/users/avatar`,
      ACTIVATE: (id: string) => `${base}/users/${id}/activate`,
      DEACTIVATE: (id: string) => `${base}/users/${id}/desactivate`,
      RESILIATION: (id: string) => `${base}/users/${id}/resiliation`,
    },

    USER_SETTINGS: {
      BASE: `${base}/user-settings`,
    },

    PROFILS: {
      BASE: `${base}/profils`,
      BY_ID: (id: string) => `${base}/profils/${id}`,
      SELECT: `${base}/profils/select`,
    },

    GROUPES: {
      BASE: `${base}/groupes`,
      BY_ID: (id: string) => `${base}/groupes/${id}`,
      SELECT: `${base}/groupes/select`,
      ACTIVATE: (id: string) => `${base}/groupes/${id}/activate`,
      TOGGLE_STRIPPED: (id: string) => `${base}/groupes/${id}/toggle-stripped`,
    },

    DROITS: {
      BASE: `${base}/droits`,
      BY_ID: (id: string) => `${base}/droits/${id}`,
      SELECT: `${base}/droits/select`,
    },

    FORFAITS: {
      BASE: `${base}/forfaits`,
      BY_ID: (id: string) => `${base}/forfaits/${id}`,
      SELECT: `${base}/forfaits/select`,
    },

    INVENTORY: {
      BASE: `${base}/inventaires`,
      BY_ID: (id: string) => `${base}/inventaires/${id}`,
      PRINT_DATA: (id: string) => `${base}/inventaires/${id}/print-data`,
      FINISHED: base + '/inventaires/finished',
      NOT_FINISHED: base + '/inventaires/notfinished',
      ALERTS: base + '/inventaires/alerts',
      VISITES: base + '/inventaires/visites',
      BULK_DELETE: base + '/inventaires/deleteMany',
      VALIDATE: base + '/inventaires/isFinished',
      RADIUS: base + '/inventaires/radius',
      STATISTICS: base + '/inventaires/statistics',
      ETAT_SANITAIRE_STATISTICS: base + '/inventaires/statistics/etat-sanitaire',
      STATISTICS_EPAYSAGE_TYPES: base + '/inventaires/statistics/epaysage-types',
      STATISTICS_DETAILED: base + '/inventaires/statistics/detailed',
      STATISTICS_GENRES: base + '/inventaires/statistics/genres',
      STATISTICS_RESINEUX_FEUILLUS: base + '/inventaires/statistics/resineux-feuillus',
      STATISTICS_STADE_DEV: base + '/inventaires/statistics/stade-dev',
      EXPORT: '',
      STATS: '',
      IMAGES: {
        UPLOAD: (id: string) => base + `/arbre/${id}/upload`,
        DELETE: (id: string, position: string) => base + `/arbre/${id}/deleteImg`,
        ROTATE: (id: string) => base + `/arbre/${id}/rotate`
      }
    },
    INVENTORY_EPAYSAGE: {
      BASE: `${base}/inventaires/epaysage`,
      SAVE_BASE: `${base}/inventaires/epaysage/base`,
      ESSENCE: `${base}/inventaires/epaysage/essence`,
    },

    ARBRES: {
      BASE: `${base}/arbres`,
      BY_ID: (id: string) => `${base}/arbres/${id}`,
      SELECT: `${base}/arbres/select`,
      UPDATE_STATUS_TRAVAUX: `${base}/arbres/update-status-travaux`,
      UPDATE_STATUS_VISITE: `${base}/arbres/update-status-visite`,
      UPDATE_ADDRESS: (id: string) => `${base}/arbres/${id}/address`,
    },

    HISTORY: {
      BASE: `${base}/history`,
      BY_ID: (id: string) => `${base}/history/${id}`,
      BY_INVENTAIRE: (inventaireId: string) => `/inventaire/${inventaireId}`,
    },


    ESPECES: {
      BASE: `${base}/especes`,
      BY_ID: (id: string) => `${base}/especes/${id}`,
      SELECT: `${base}/especes/select`,
      RESTORE: (id: string) => `${base}/especes/${id}/restore`,
      UPDATE_IMAGE: (id: string) => `${base}/especes/${id}/update-image`,
    },

    EPAYSAGES: {
      BASE: `${base}/epaysages`,
      BY_ID: (id: string) => `${base}/epaysages/${id}`,
      SELECT: `${base}/epaysages/select`,
      VILLES: `${base}/epaysages/villes`,
      PAYS: `${base}/epaysages/pays`,
    },

    ESSENCES: {
      BASE: `${base}/essences`,
      BY_EPAYSAGE: (epaysageId: string) => `${base}/epaysages/${epaysageId}/essences`,
      BY_ID: (epaysageId: string, essenceId: string) => `${base}/epaysages/${epaysageId}/essences/${essenceId}`,
      SELECT: (epaysageId: string) => `${base}/epaysages/${epaysageId}/essences/select`,
      UPDATE_STATUS_TRAVAUX: `${base}/essences/update-status-travaux`,
      UPDATE_STATUS_VISITE: `${base}/essences/update-status-visite`,
    },

    CHAMPIGNONS: {
      BASE: `${base}/champignons`,
      BY_ID: (id: string) => `${base}/champignons/${id}`,
      SELECT: `${base}/champignons/select`,
      CATEGORIES: `${base}/champignons/categories`,
      RESTORE: (id: string) => `${base}/champignons/${id}/restore`,
      UPDATE_IMAGE: (id: string) => `${base}/champignons/${id}/update-image`,
    },

    NUISIBLES: {
      BASE: `${base}/nuisibles`,
      BY_ID: (id: string) => `${base}/nuisibles/${id}`,
      SELECT: `${base}/nuisibles/select`,
    },

    PLANTATIONS: {
      BASE: `${base}/plantations`,
      BY_ID: (id: string) => `${base}/plantations/${id}`,
      SELECT: `${base}/plantations/select`,
      VALIDATE: (id: string) => `${base}/plantations/${id}/validate`,
      STATISTICS: `${base}/plantations/statistics`,
    },

    SMS: {
      BASE: `${base}/sms`,
      SEND: `${base}/sms/send`,
    },

    SETTINGS: {
      BASE: `${base}/settings`,
      SUBSCRIPTION: `${base}/settings/subscription`,
      SUBSCRIPTION_PUBLIC: `${base}/settings/subscription/public`,
      SUBSCRIPTION_INITIALIZE: `${base}/settings/subscription/initialize`,
    },

    CONTACTS: {
      BASE: `${base}/contacts`,
      BY_ID: (id: string) => `${base}/contacts/${id}`,
      SELECT: `${base}/contacts/select`,
      STATUS: (id: string) => `${base}/contacts/${id}/status`,
      STATISTICS: `${base}/contacts/statistics`,
    },
    BEVA: {
      BASE: `${base}/beva`,
      BY_INVENTAIRE: (inventaireId: string) => `/inventaire/${inventaireId}`,
      BY_ESSENCE: (essenceId: string) => `/essence/${essenceId}`,
      BULK: {
        ALL: `${base}/beva/bulk/all`,
        INVENTAIRES: `${base}/beva/bulk/inventaires`,
        STATISTICS: `${base}/beva/statistics`,
      },
      INVENTAIRES_BULK: {
        BULK: `${base}/inventaires/beva/bulk`,
        INVENTAIRES: `${base}/inventaires/beva/inventaires`,
      },
    },

    TRAVAUX: {
      BASE: `${base}/travaux`,
      VALID: `${base}/travaux/valid`,
      INVENTAIRES: `${base}/travaux/inventaires`,
      INVENTAIRES_SEARCH: `${base}/travaux/inventaires/search`,
      ALERTS: `${base}/travaux/alerts`,
      ALERTS_SEARCH: `${base}/travaux/alerts/search`,
      ALERTS_MONTHLY_STATS: `${base}/travaux/alerts/monthly-stats`,
      MONTHLY_BAR_CHART: `${base}/travaux/monthly-bar-chart`,
      EXAMENS: `${base}/travaux/examens`,
      STATISTICS: `${base}/travaux/statistics`,
    },
    SITE_CONTENT: {
      BASE: `${base}/site-content`,
    },
    MEDIA: {
      BASE: `${base}/media`,
      UPLOAD: `${base}/media/upload`,
      UPLOAD_MULTIPLE: `${base}/media/upload/multiple`,
      STATS: `${base}/media/stats`,
      FOLDERS: `${base}/media/folders`,
      BULK_DELETE: `${base}/media/bulk`,
      BULK_UPDATE: `${base}/media/bulk/update`,
      BY_ID: (id: string) => `${base}/media/${id}`,
    },

    AUDIT_LOGS: {
      BASE: `${base}/audit-logs`,
      BY_ID: (id: string) => `${base}/audit-logs/${id}`,
      STATS: `${base}/audit-logs/stats/summary`,
      METRICS: `${base}/audit-logs/metrics/prometheus`,
      EXPORT: `${base}/audit-logs/export`,
      RELATED: (id: string) => `${base}/audit-logs/${id}/related`,
    },
  } as const;
};

// Create and export the endpoints
export const ENDPOINTS = createEndpoints(API_CONFIG.baseURL);

// Helper type to get endpoint paths
export type EndpointPath = typeof ENDPOINTS;

// Helper function to get full URL for an endpoint
export const getEndpointUrl = (path: string): string => {
  return `${API_CONFIG.baseURL}${path}`;
};

// Helper function to check if URL is an API endpoint
export const isApiUrl = (url: string): boolean => {
  return url.startsWith(API_CONFIG.baseURL);
};

// Export API configuration
export { API_CONFIG };
